import { useQuery, UseQueryResult } from 'react-query'
import { ProducersResponse } from './types'
import { fetchProducers } from './services'

export default function useProducersSearch(searchPhrase: string): UseQueryResult<ProducersResponse> {
   return useQuery(['producersSearch', searchPhrase], () => fetchProducers(searchPhrase))
}
